import { useState } from "react";
import _ from "lodash";

const useFormDirty = () => {
    const [initialState, setInitialState] = useState(null);
    const [ignoreFields, setIgnoreFields] = useState([]);

    const initializeData = (initialState, initialIgnoreFields = []) => {
        setInitialState(initialState);
        setIgnoreFields(initialIgnoreFields);
    };

    const normalizeValue = (value) => {
        if (typeof value !== 'string') {
            return value;
        }
        
        const date = new Date(value);

        if (isNaN(date.getTime())) {
            return value;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const initializeFilteredObject = (stateObject, compareStateObject) => {
        const filteredObject = {};
        Object
            .keys(stateObject)
            .filter(key => !ignoreFields.includes(key)) // Exclude ignored fields
            .filter(nullfields => stateObject[nullfields] !== undefined && stateObject[nullfields] !== null) // Exclude null or undefined fields
            .filter(missingfields => compareStateObject === null || (compareStateObject[missingfields.toLowerCase()] !== undefined && compareStateObject[missingfields.toLowerCase()] !== null)) // Exclude fields missing in compareStateObject
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) // Sort keys alphabetically, case-insensitive
            .forEach(key => {
                const lowerKey = key.toLowerCase();
                let value = stateObject[key];
                value = normalizeValue(value);
                filteredObject[lowerKey] = value;
            });

        return filteredObject;
    };

    const isDirty = (currentState) => {
        if (!currentState)
            return;

        const currentStateFiltered = initializeFilteredObject(currentState, null);
        const initialStateFiltered = initializeFilteredObject(initialState, currentStateFiltered);
        return !_.isEqual(initialStateFiltered, currentStateFiltered);
    };

    return {
        initializeData,
        isDirty
    };
}

export default useFormDirty;